var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.71 21.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e50914;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #080909;\n      }\n\n      .cls-3 {\n        fill: #2e2e2e;\n      }\n\n      .cls-4 {\n        fill: #afafaf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.31,
    y: 16.5,
    width: 1.84,
    height: 1.84,
    rx: 0.5,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.02,
    y: 16.5,
    width: 1.84,
    height: 1.84,
    rx: 0.5,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.31,
    y: 18.79,
    width: 1.84,
    height: 1.84,
    rx: 0.5,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.02,
    y: 18.79,
    width: 1.84,
    height: 1.84,
    rx: 0.5,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.91,11.44H.69c-.37,0-.67.3-.67.67v3.26c0,.37.3.67.67.67h3.26c.37,0,.67.3.67.67v3.26c0,.37.3.67.67.67h3.26c.37,0,.67-.3.67-.67v-7.85c0-.37-.3-.67-.67-.67h-1.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.24,
    width: 10.19,
    height: 10.19,
    rx: 0.67,
    ry: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.21,
    y: 10.43,
    width: 10.19,
    height: 10.19,
    rx: 0.67,
    ry: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.31,
    y: 0.24,
    width: 4.09,
    height: 4.09,
    rx: 0.67,
    ry: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.22,
    y: 0.24,
    width: 4.09,
    height: 4.09,
    rx: 0.67,
    ry: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.31,
    y: 5.34,
    width: 4.09,
    height: 4.09,
    rx: 0.67,
    ry: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.22,
    y: 5.34,
    width: 4.09,
    height: 4.09,
    rx: 0.67,
    ry: 0.67
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.44,
    y: 0.23,
    width: 1.16,
    height: 9.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.27 .23 29.27 9.92 30.42 9.92 30.42 2.08 35.77 9.92 37.45 9.92 37.45 .23 36.29 .23 36.29 8.09 31.11 .23 29.27 .23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.09 .23 40.09 9.92 41.22 9.92 41.22 5.75 45.74 5.75 45.74 4.59 41.27 4.59 41.27 1.41 46.06 1.41 46.06 .23 40.09 .23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.23.02c-2.76,0-5,2.26-5,5.05s2.24,5.05,5,5.05,5-2.26,5-5.05S55,.02,52.23.02ZM52.23,8.94c-2.05,0-3.71-1.74-3.71-3.9s1.66-3.9,3.71-3.9,3.71,1.74,3.71,3.9-1.66,3.9-3.71,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.64,2.06l.96-.96S63.73-.01,61.86,0c-.76,0-1.52.18-2.13.63-.56.41-1.08,1.06-1.08,2.07,0,0-.19,2.34,2.5,2.87.21.04.41.09.61.16.72.26,2.11.94,1.48,2.25,0,0-.52.94-1.62.89,0,0-1.34.25-2.18-1.04l-1.08,1.05s1.08,1.28,3.01,1.25c0,0,1.99.23,3.04-1.37.19-.29.32-.62.39-.96.14-.66.18-1.73-.74-2.55-.33-.3-.75-.5-1.18-.62-.4-.11-1.04-.28-1.7-.46,0,0-.86-.24-1.06-1.05-.18-.71.25-1.43.93-1.7.66-.25,1.66-.36,2.59.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "66.87 .25 66.87 9.89 73.23 9.89 73.23 8.73 68.07 8.73 68.07 5.55 72.68 5.55 72.68 4.39 68.07 4.39 68.07 1.39 73.08 1.39 73.08 .25 66.87 .25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.27,7.69c-.68.77-1.64,1.25-2.72,1.25-2.05,0-3.71-1.74-3.71-3.9s1.66-3.9,3.71-3.9c.96,0,1.83.39,2.49,1.01l.94-.77c-.9-.86-2.1-1.38-3.44-1.38-2.76,0-5,2.26-5,5.05s2.24,5.05,5,5.05c1.43,0,2.73-.61,3.64-1.59l-.92-.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.77 .25 83.77 1.09 87.09 1.09 87.09 9.89 87.91 9.89 87.91 1.06 91.2 1.06 91.2 .25 83.77 .25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.23,5.27s1.9-.12,2.38-1.63c.42-1.32-.32-2.76-1.62-3.21-.06-.02-.11-.04-.17-.05-.3-.09-.62-.12-.93-.12h-3.14v9.64h.76v-4.63l1.84.03,2.73,4.59h.99l-2.83-4.63ZM93.57,4.51V1.06h2.44c.16,0,.32.01.47.05.01,0,.02,0,.03,0,1.18.32,1.69,1.53,1.05,2.57-.14.23-.33.4-.52.52-.33.21-.71.3-1.1.3h-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.71.25h-1.12l-4.24,9.64h1.12l1-2.56h5.05l1.08,2.56h1.08l-3.98-9.64ZM101.85,6.48l2.17-5.29h.16l2.07,5.29h-4.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.07,
    y: 0.25,
    width: 0.82,
    height: 9.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.72 .25 113.72 9.89 114.61 9.89 114.61 1.52 120.43 9.89 121.68 9.89 121.68 .25 120.75 .25 120.75 8.59 114.94 .25 113.72 .25"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.46,20.64v-4.88h3.09v.47h-2.53v1.7h2.39v.47h-2.39v1.77h2.53v.47h-3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.21,15.76v4.88h-.56v-.62c-.1.21-.25.38-.45.49s-.43.17-.69.17c-.29,0-.56-.07-.78-.22-.23-.15-.4-.35-.53-.62-.12-.27-.19-.57-.19-.92s.06-.65.19-.91c.12-.26.3-.47.53-.61.23-.14.49-.21.78-.21.26,0,.49.06.69.17s.34.28.45.49v-2.09h.56ZM32.38,19.89c.18-.22.27-.54.27-.95s-.09-.73-.27-.95c-.18-.22-.43-.33-.76-.33s-.58.11-.76.33c-.18.22-.27.53-.27.93s.09.73.27.96.44.34.76.34.58-.11.76-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.9,17.27v3.37h-.55v-.57c-.11.2-.25.36-.45.46-.19.11-.41.16-.65.16-.4,0-.7-.11-.91-.34-.2-.22-.3-.56-.3-.99v-2.09h.56v2.08c0,.3.06.52.18.66s.31.21.57.21c.29,0,.53-.1.71-.29s.27-.44.27-.76v-1.9h.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.33,20.47c-.25-.14-.43-.35-.56-.61-.13-.26-.2-.57-.2-.92s.07-.66.2-.92c.14-.27.33-.47.57-.62.25-.15.54-.22.87-.22.23,0,.45.04.66.12.22.08.39.19.53.32l-.19.42c-.32-.26-.64-.39-.97-.39-.35,0-.62.11-.81.34-.19.23-.29.54-.29.96s.1.72.29.94c.19.22.46.33.81.33s.65-.13.97-.39l.19.42c-.14.13-.32.24-.54.32-.22.08-.44.12-.67.12-.33,0-.62-.07-.87-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.25,17.51c.21.22.31.55.31,1v2.12h-.55v-.57c-.09.2-.22.35-.4.46s-.39.16-.62.16c-.22,0-.42-.04-.6-.13-.18-.09-.33-.21-.43-.37-.11-.16-.16-.33-.16-.52,0-.25.06-.45.19-.59.13-.14.34-.24.64-.3.29-.06.71-.09,1.23-.09h.15v-.23c0-.28-.06-.49-.17-.61s-.3-.19-.56-.19c-.39,0-.77.12-1.16.36l-.19-.41c.17-.12.39-.23.63-.3.25-.08.49-.11.72-.11.43,0,.75.11.96.33ZM45.75,19.96c.18-.19.27-.43.27-.72v-.2h-.12c-.41,0-.72.02-.93.05-.21.03-.36.09-.45.17-.09.08-.14.2-.14.36,0,.18.07.33.2.45.13.12.3.18.5.18.28,0,.5-.09.68-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.21,20.22l-.03.44c-.11.02-.22.03-.35.03-.41,0-.71-.11-.92-.32-.21-.21-.31-.51-.31-.89v-1.77h-.66v-.44h.66v-1.02h.56v1.02h.96v.44h-.96v1.73c0,.53.24.8.73.8.1,0,.2,0,.3-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.42,19.04h-2.46c.02.39.12.69.32.89.19.2.47.3.82.3.39,0,.75-.13,1.08-.4l.19.41c-.15.14-.34.25-.57.33-.23.08-.47.12-.71.12-.53,0-.94-.15-1.24-.46-.3-.31-.45-.74-.45-1.28,0-.35.07-.65.2-.92.13-.27.32-.47.56-.62s.52-.22.83-.22c.45,0,.8.15,1.05.44.25.29.38.7.38,1.21v.21ZM52.29,17.9c-.18.19-.28.45-.32.78h1.96c0-.34-.09-.6-.26-.79-.16-.18-.39-.27-.68-.27s-.53.09-.71.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.06,19.93h.71v.71h-.71v-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.98,20.64v-4.88h3.09v.47h-2.53v1.7h2.39v.47h-2.39v1.77h2.53v.47h-3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.55,18.9l1.4,1.74h-.68l-1.05-1.31-1.05,1.31h-.68l1.4-1.74-1.32-1.63h.68l.97,1.23.97-1.23h.69l-1.32,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.78,20.47c-.25-.14-.43-.35-.56-.61-.13-.26-.2-.57-.2-.92s.07-.66.2-.92c.14-.27.33-.47.57-.62.25-.15.54-.22.87-.22.23,0,.45.04.66.12.22.08.39.19.53.32l-.19.42c-.32-.26-.64-.39-.97-.39-.35,0-.62.11-.81.34-.19.23-.29.54-.29.96s.1.72.29.94c.19.22.46.33.81.33s.65-.13.97-.39l.19.42c-.14.13-.32.24-.54.32-.22.08-.44.12-.67.12-.33,0-.62-.07-.87-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.15,19.04h-2.46c.02.39.12.69.32.89.19.2.47.3.82.3.39,0,.75-.13,1.08-.4l.19.41c-.15.14-.34.25-.57.33-.23.08-.47.12-.71.12-.53,0-.94-.15-1.24-.46-.3-.31-.45-.74-.45-1.28,0-.35.07-.65.2-.92.13-.27.32-.47.56-.62s.52-.22.83-.22c.45,0,.8.15,1.05.44.25.29.38.7.38,1.21v.21ZM75.01,17.9c-.18.19-.28.45-.32.78h1.96c0-.34-.09-.6-.26-.79-.16-.18-.39-.27-.68-.27s-.53.09-.71.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.82,20.64v-4.88h.56v4.88h-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.24,19.93h.71v.71h-.71v-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.16,20.64v-4.88h3.09v.47h-2.53v1.7h2.39v.47h-2.39v1.77h2.53v.47h-3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.79,18.52v2.12h-.56v-2.09c0-.31-.05-.54-.16-.68s-.28-.21-.52-.21c-.28,0-.5.09-.67.28-.16.19-.24.45-.24.78v1.92h-.56v-2.09c0-.31-.06-.54-.17-.68-.11-.14-.29-.21-.53-.21-.28,0-.5.09-.66.28-.16.19-.24.45-.24.78v1.92h-.56v-3.37h.55v.53c.1-.2.24-.35.42-.46.18-.11.39-.16.62-.16.52,0,.87.22,1.03.66.1-.21.24-.37.44-.49.2-.12.42-.18.68-.18.75,0,1.12.45,1.12,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.1,17.41c.23.15.4.35.53.62.12.27.19.57.19.92s-.06.66-.19.92c-.12.26-.3.46-.52.61-.22.14-.49.21-.79.21-.26,0-.49-.06-.69-.17s-.34-.28-.45-.49v1.86h-.56v-4.62h.56v.58c.1-.21.25-.38.45-.49s.43-.17.69-.17c.29,0,.56.07.78.22ZM99.97,19.89c.18-.22.27-.54.27-.94s-.09-.72-.27-.95c-.18-.23-.43-.34-.76-.34s-.58.11-.76.33c-.18.22-.27.54-.27.95s.09.73.27.95c.18.22.43.34.76.34s.58-.11.76-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.06,20.47c-.24-.14-.43-.35-.56-.61-.13-.27-.2-.57-.2-.92s.07-.66.2-.92c.13-.27.32-.47.56-.61s.52-.21.84-.21.6.07.84.21.43.35.56.61c.13.27.2.57.2.92s-.07.66-.2.92c-.13.27-.32.47-.56.61s-.53.21-.84.21-.6-.07-.84-.21ZM104.67,19.89c.18-.22.27-.54.27-.96s-.09-.73-.27-.95c-.18-.22-.43-.34-.76-.34s-.58.11-.76.34c-.18.22-.27.54-.27.95s.09.73.27.96.43.33.76.33.59-.11.77-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.65,17.27h.56l-1.25,3.37h-.54l-.95-2.61-.96,2.61h-.53l-1.25-3.37h.58l.96,2.71.98-2.71h.48l.96,2.71.96-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.46,19.04h-2.46c.02.39.12.69.32.89.19.2.47.3.82.3.39,0,.75-.13,1.08-.4l.19.41c-.15.14-.34.25-.57.33-.23.08-.47.12-.71.12-.53,0-.94-.15-1.24-.46-.3-.31-.45-.74-.45-1.28,0-.35.07-.65.2-.92.13-.27.32-.47.56-.62s.52-.22.83-.22c.45,0,.8.15,1.05.44.25.29.38.7.38,1.21v.21ZM114.32,17.9c-.18.19-.28.45-.32.78h1.96c0-.34-.09-.6-.26-.79-.16-.18-.39-.27-.68-.27s-.53.09-.71.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.04,17.67l-.37.03c-.35.03-.6.14-.75.33s-.23.41-.23.69v1.92h-.56v-3.37h.55v.59c.19-.39.56-.61,1.11-.66h.2s.05.47.05.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121,19.93h.71v.71h-.71v-.71Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 25.41,
    y: 12.58,
    width: 96.24,
    height: 0.49
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6580498de010b72fba62d4e3d9e9f1a3.svg";
export { ForwardRef as ReactComponent };